import { FormatPhone, TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { FieldArray, useFormikContext } from 'formik';
import React from 'react';
import EmailAdicional from './EmailAdicional';
import TelefoneAdicional from './TelefoneAdicional';

const Contato = ({
  contato,
  isEstrangeira,
  index,
  handleChange,
  handleBlur,
  errors,
  touched,
  readOnly,
  submitCount,
}) => {
  const contatosErrors = errors?.pessoa?.contatos || [{}];
  const contatosTouched = touched?.pessoa?.contatos || [{}];
  const { email: emailError, emailsAdicionais: emailsAdicionaisErrors } = contatosErrors[index];
  const { email: emailTouched, emailsAdicionais: emailsAdicionaisTouched } = contatosTouched[index];
  const inputSize = isEstrangeira ? 10 : 12;

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          readOnly={readOnly}
          autoFocus
          id={`pessoa.contatos[${index}].nomeReferencia`}
          fullWidth
          onChange={handleChange}
          onBlur={handleBlur}
          value={contato.nomeReferencia}
          label="Nome do contato"
          error={errors?.pessoa?.contatos?.length > index && errors.pessoa.contatos[index].nomeReferencia}
          touched={
            errors?.pessoa?.contatos?.length > index &&
            (submitCount > 0 || (touched?.pessoa?.contatos?.length && touched.pessoa.contatos[index].nomeReferencia)) &&
            errors.pessoa.contatos[index].nomeReferencia
          }
          maxLength={30}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <Grid container spacing={2}>
          {isEstrangeira && (
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <TextInput
                readOnly={readOnly}
                id={`pessoa.contatos[${index}].codigoPais`}
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                value={contato.codigoPais}
                label="Código"
                maxLength={3}
              />
            </Grid>
          )}
          <Grid item xs={inputSize} sm={inputSize} md={inputSize} lg={inputSize} xl={inputSize}>
            <TextInput
              readOnly={readOnly}
              id={`pessoa.contatos[${index}].numero`}
              fullWidth
              onChange={handleChange}
              onBlur={handleBlur}
              value={contato.numero}
              label="Telefone principal"
              InputProps={{ inputComponent: FormatPhone }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TelefoneAdicional
            readOnly={readOnly}
            contatoIndex={index}
            isEstrangeira={isEstrangeira}
            inputSize={inputSize}
            telefonesAdicionais={contato.telefonesAdicionais}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextInput
            readOnly={readOnly}
            id={`pessoa.contatos[${index}].email`}
            required={contato.email && emailTouched && emailError}
            fullWidth
            label="E-mail principal"
            onChange={handleChange}
            onBlur={handleBlur}
            value={contato.email}
            maxLength={100}
            touched={emailTouched}
            error={emailError}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <EmailAdicional
            readOnly={readOnly}
            contatoIndex={index}
            emailsAdicionais={contato.emailsAdicionais}
            error={emailsAdicionaisErrors}
            touched={emailsAdicionaisTouched}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Grid>
      </Grid>
    </>
  );
};

const ContatoForm = ({ readOnly }) => {
  const { values, handleChange, handleBlur, touched, errors, submitCount } = useFormikContext();
  const { pessoa = {} } = values;
  const { contatos = [{}] } = pessoa;
  const isEstrangeira = pessoa?.tipoPessoa === 'ESTRANGEIRA';

  return (
    <FieldArray name="contatos">
      {(arrayHelpers) => {
        return contatos.map((contato, index) => {
          return (
            <Contato
              key={index}
              readOnly={readOnly}
              index={index}
              contato={contato}
              isEstrangeira={isEstrangeira}
              arrayHelpers={arrayHelpers}
              handleChange={handleChange}
              handleBlur={handleBlur}
              touched={touched}
              errors={errors}
              submitCount={submitCount}
            />
          );
        });
      }}
    </FieldArray>
  );
};

export default ContatoForm;
